import PropTypes from "prop-types";

import { TRANSACTION_ORIGIN_TYPES } from "../CONSTANTS";

function TransactionOriginType(props) {
  const { type } = props;

  return TRANSACTION_ORIGIN_TYPES[type] || type;
}

TransactionOriginType.displayName = "TransactionOriginType";

TransactionOriginType.propTypes = {
  type: PropTypes.number,
};

TransactionOriginType.defaultProps = {};

export default TransactionOriginType;



// WEBPACK FOOTER //
// ./src/components/processing/transaction/TransactionOriginType.js